/**
 * Login — `/login` route wrapper.
 *
 * Phase 2.9 refactor: the actual step flow lives in `LoginSteps.tsx`, shared
 * with the in-scene `<LoginModal>`. This file is now just the full-page chrome
 * (the chunky `bg-pop-night` background + the "← Zpět" link) that the route
 * surface wraps around the same three-phase content.
 *
 * The mocked endpoint always returns Anna, so the welcome screen is hard-coded.
 * See wiki `Design-Specs/Photo-Login.md` for canonical copy and styling.
 */
import { Link, useNavigate } from 'react-router-dom'
import LoginSteps from '@/components/LoginSteps'

export default function Login() {
  const navigate = useNavigate()
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4 py-10 bg-pop-night text-pop-cream">
      <Link to="/" className="pixel-btn-secondary absolute top-6 left-6 text-xs">
        ← Zpět
      </Link>

      <LoginSteps
        onComplete={() => navigate('/')}
        onCancel={() => navigate('/')}
      />
    </main>
  )
}
